module.exports = __webpack_public_path__ + "img/CS-UL-II_Overview.2ba57533.jpg";